import { render, staticRenderFns } from "./PPage.vue?vue&type=template&id=7f2f9c14&scoped=true"
import script from "./PPage.vue?vue&type=script&lang=ts"
export * from "./PPage.vue?vue&type=script&lang=ts"
import style0 from "./PPage.vue?vue&type=style&index=0&id=7f2f9c14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2f9c14",
  null
  
)

export default component.exports